import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	selectedScap: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const scapSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setScapsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil((totalItems || 0) / (perPage || 10));
		},

		setLoadingScaps: (state, action) => {
			state.loading = action.payload;
		},

		setSelectedScap: (state, action) => {
			state.selectedScap = action.payload;
		},

		setAddScap: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setDeleteScap: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
		},
		setEditScap: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((scap) => (scap.id === id ? { ...scap, ...updatedData } : scap));
		},
	},
});

export const {
	setScapsData,
	setLoadingScaps,
	setSelectedScap,
	setAddScap,
	setDeleteScap,
	setEditScap,
} = scapSlice.actions;

export default scapSlice.reducer;
